import { useState, useMemo } from "react";
import { FaAngleLeft } from "react-icons/fa";
import "../styles/tabular_data.scss";

// The panel is entirely CSS-driven for responsiveness: `.table-container`'s
// width is set in tabular_data.scss (60vw on desktop, 88vw on small
// screens), and `.table-wrapper` scrolls both directions so a wide table
// never forces the panel itself wider than that — it scrolls inside
// instead of squeezing columns unreadably or overflowing the viewport.
const TabularData = ({ layers, handleRowClick }) => {
  const [toggleTable, setToggleTable] = useState(false);

  const layerKeys = Object.keys(layers);
  const [selectedLayer, setSelectedLayer] = useState(layerKeys[0] || "");
  const [selectedRowId, setSelectedRowId] = useState(null);

  // Get selected layer data safely
  const selectedData = layers[selectedLayer]?.data || [];

  const hiddenColumns = [
    "geom",
    "id",
    "fid",
    "collected_",
    "date_colle",
    "mappedby",
    "photo",
    "mapping_da",
    "meter_imag",
    "geom",
    "__gid",
    "uid",
    "path",
    "scuid",
    "cuid",
    "layer",
    "enumerator",
    "device id",
    "captured o",
    "what is yo",
    "what is _1", "do you cur",
    "how much d",
    "how much_1",
    "how much v",
    "how much_2",
    "what is _2",
    "what are y",
    "what kind",
    "do you hav",
    "what is _3",
    // "what is _4",
    "what is _5",
    "what is _6",
    "what is _7",
    "what is _8",
    "what type",
    "what is _9",
    "what typ_1",
    "what is 10", "what is th", "what is 11", "what is 12", "what is 13", "is the met", "what is 14", "what is 15", "how is the", "what is 16",
    "is the m_1", "what is 17", "what is 18", "what is 19", "what is 20", "what is 21", "what is 22", "which type", "what are_1", "what is 23",
    "provide an", "longitude", "latitude", "accuracy", "completion", "route_name", "n", "distance", "feature_x", "feature_y", "nearest_x", "nearest_y"
  ];

  const columns = useMemo(() => {
    if (!selectedData.length) return [];

    return Object.keys(selectedData[0]).filter(
      (key) => !hiddenColumns.includes(key)
    );
  }, [selectedData]);

  return (
    <div className={`stats-table ${toggleTable ? "open" : ""}`}>
      {toggleTable && (
        <div className="table-container">
          {/* Layer Selector */}
          <div className="layer-selector">
            <select
              value={selectedLayer}
              onChange={(e) => setSelectedLayer(e.target.value)}
            >
              {layerKeys.map((layerName) => (
                <option key={layerName} value={layerName}>
                  {layerName}
                </option>
              ))}
            </select>
          </div>

          {/* Table — scrolls both ways inside this wrapper rather than
              resizing the panel or breaking layout on small screens. */}
          <div className="table-wrapper">
            {selectedData.length > 0 ? (
              <table>
                <thead>
                  <tr>
                    {columns.map((col) => (
                      <th key={col}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {selectedData.map((row, rowIndex) => (
                    <tr
                      key={rowIndex}
                      onClick={() => {
                        setSelectedRowId(row.id || row.fid || rowIndex); // fallback if needed
                        handleRowClick(row, selectedLayer);
                      }}
                      className={
                        (row.id || row.fid || rowIndex) === selectedRowId
                          ? "active-row"
                          : ""
                      }
                    >
                      {columns.map((col) => (
                        <td key={col}>
                          {typeof row[col] === "object"
                            ? JSON.stringify(row[col])
                            : row[col]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="no-data">No data available</div>
            )}
          </div>
        </div>
      )}

      {/* Toggle tab — always visible on the right edge, whether the panel
          is open or not, so it's never lost inside a collapsed drawer. */}
      <button
        className={`toggle-table ${toggleTable ? "close-table" : ""}`}
        onClick={() => setToggleTable(!toggleTable)}
      >
        <FaAngleLeft />
        <span className="tooltip">{toggleTable ? "Close" : "Data"}</span>
      </button>
    </div>
  );
};

export default TabularData;
